@if (isLoading) {
  <mat-spinner></mat-spinner>
}

@if (projects().length) {
  <app-submit-report [projects]="projects()"></app-submit-report>

  <app-emp-report-export
    [enabledControls]="{ date: false, dateRangeToggle: true, employee: false, project: true }"
    [title]="'ADMIN.CLIENT_HOURS.TITLE' | translate"
    (emitSubmit)="onSubmit($event)"
    [projects]="projects()"
  ></app-emp-report-export>

  <app-emp-report-export
    [enabledControls]="{ date: false, dateRangeToggle: true, employee: false, project: true }"
    [title]="'ADMIN.CLIENT_HOURS.TITLE_SYNECHRON' | translate"
    (emitSubmit)="onSubmitSynechron($event)"
    [projects]="projects()"
  ></app-emp-report-export>
}

<h2 class="section-title">
  {{ 'ADMIN.CLIENT_HOURS.SUB_TITLE' | translate }}
</h2>

@if (projects().length) {
  <app-calendar [isCalendarHome]="false" [projects]="projects()"></app-calendar>
}
